import React from 'react';

interface SectionWrapperProps {
  children: React.ReactNode | string; 
}

const Block: React.FC<SectionWrapperProps> = ({ children }) => {
  return (
    <section className="px-10 py-2">
      <div className="bg-white shadow-md rounded-lg p-6 ">
        {children}
      </div>
    </section>
  );
};

export default Block;
